import React, { useContext } from "react";
import MyContext from "../../../StoreContext";
import Gmail from "./Gmail";
import Twitter from "./Twitter";
import Whatsapp from "./Whatsapp";

const base_phone = "https://static.wholemeaning.com/demo/base.webp";

/**
 * Componente principalmente un switch que dependiendo de la industria y
 * el canal elegido muestra un screeshot distinto
 */
const Device = () => {
  const { industry, channel } = useContext(MyContext);

  if (industry) {
    switch (channel) {
      case "gmail":
        return <Gmail />;
      case "twitter":
        return <Twitter />;
      case "whatsapp":
        return <Whatsapp />;

      default:
        return <img src={base_phone} alt='phone' className='phoneDimension' />;
    }
  } else {
    return <img src={base_phone} alt='phone' className='phoneDimension' />;
  }
};

export default Device;
